import { render, staticRenderFns } from "./ListaPrecantidadesFoodcourt.vue?vue&type=template&id=7b0cc11a&scoped=true"
import script from "./ListaPrecantidadesFoodcourt.vue?vue&type=script&lang=js"
export * from "./ListaPrecantidadesFoodcourt.vue?vue&type=script&lang=js"
import style0 from "./ListaPrecantidadesFoodcourt.vue?vue&type=style&index=0&id=7b0cc11a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0cc11a",
  null
  
)

export default component.exports